import { Component, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChangepasswordComponent } from '../../shared/changepassword/changepassword.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fb-header',
  templateUrl: './fb-header.component.html',
  styleUrls: ['./fb-header.component.scss']
})
export class FbHeaderComponent implements OnInit {
  whiteLabelLogo: string = '';
  isLoggedIn: boolean;
  notificationCount: number;
  avatarSrc: string;
  userFN: string;
  userLN: string;
  observableSubscription$ = new Subject();
  userType: string;
  isAdmin = false;
  @Input() isFBModulePreview = false;
  rolebasedProfileMenu = [
    {
      key: 'Beneficiary',
      value: [
        {
          id: 1,
          name: 'Beneficiary Profile',
          path: 'beneficiary-landing/beneficiaries/profile'
        }
      ]
    },
    {
      key: 'Petitioner',
      value: [
        {
          id: 1,
          name: 'Petitioner Profile',
          path: 'petitioner-landing/companies/profile'
        }
      ]
    },
    {
      key: 'PetitionerAdmin',
      value: [
        {
          id: 1,
          name: 'Petitioner Admin Profile',
          path: ''
        }
      ]
    },
    {
      key: 'Attorney',
      value: [
        {
          id: 1,
          name: 'Attorney Profile',
          path: 'attorney-landing/attorney/attorneys/profile'
        }
      ]
    }
  ];
  profileMenu: any[];

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    public changePwdDialog: MatDialog,
    private router: Router
  ) {
    this.isLoggedIn = true;
    this.notificationCount = 0;
  }

  ngOnInit() {
    var domainName = this.userService.domainName;
    this.authenticationService.logoCalling(domainName)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(data => {
        if (data.data == "" || data.data == undefined) {
          this.whiteLabelLogo = '';
          return
        }
        if (data.data.logo !== '' || data.data.logo !== null) {
          this.whiteLabelLogo = 'data:image/jpeg;base64,' + data.data.logo;
        }
      });

    this.authenticationService.currentUser
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data) => {
        this.userFN = data?.firstname;
        this.userLN = data?.lastName;
        this.userType = data?.userType;
        data['permissions'].forEach(el => {
          if (el === 'ISADMIN') { this.isAdmin = true; }
        });
        this.profileMenu = this.rolebasedProfileMenu.find(y => y.key === data['userType']) ?
          this.rolebasedProfileMenu.find(y => y.key === data['userType']).value : [];
      });
  }

  handleNavigationCLick(destination) {

  }

  handleLogout() {
    if (!this.isFBModulePreview) {
      this.router.navigate(['/logout']);
    }
  }

  ChangePwdDialogueOpen() {
    if (!this.isFBModulePreview) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      // dialogConfig.height = 'auto';
      dialogConfig.width = '600px';
      dialogConfig.data = { caption: 'Change Password', expiredCred: false };
      dialogConfig.panelClass = 'changePassword';
      dialogConfig.disableClose = true;
      const dialogRef = this.changePwdDialog.open(ChangepasswordComponent, dialogConfig).afterClosed().subscribe();
    }
  }

}
